import gql from 'graphql-tag';

export const QUERY = gql([
    `
query FindListeRobesContent($id: String!, $dateFilter: String!)
{
  models: queryFicheProduitRobeContents(top: 1000, skip: 0, filter: null, search: null, orderby: "data/brandId/iv") {
    id
    data {
        brandId {
            iv
          }
          pageTitle {
            iv
          }
      thumbTitle {
        iv
      }
      thumbSubTitle {
        iv
      }
      thumbImage {
        iv {
          url
          fileSize
        }
      }
      type{
        iv
      }
      longueur{
        iv
      }
      manches{
        iv
      }
      matiere{
        iv
      }
      coupes{
        iv
      }
      decollete{
        iv
      }
      selections{
        iv{id}
      }
      productPrice{
        iv
      }
    }
  }
  content: findListeRobesContent(id: $id) {
    data {
      brandId{
        iv
      }
      titleBlocTitle {
        iv
      }
      titleBlocSubTitle {
        iv
      }
      titleBlocFontSizeTitle {
        iv
      }
      titleBlocFontSizeSubTitle {
        iv
      }
      titleBlocTagline {
        iv
      }
      titleBlocColor {
        iv
      }
      titleBlocCtaLink {
        iv
      }
      titleBlocCtaText {
        iv
      }
      titleBlocCtaStyle {
        iv
      }
      titleBlocCtaLink2 {
        iv
      }
      titleBlocCtaText2 {
        iv
      }
      titleBlocCtaStyle2 {
        iv
      }
      titleBlocPicture {
        iv {
          url
        }
      }
      titleBlocTextColor {
        iv
      }
      titleBlocHorizontalPosition {
        iv
      }
      titleBlocJustification {
        iv
      }

      description {
        iv
      }
      descriptionFontSize {
        iv
      }
      descriptionTextColor {
        iv
      }

      mention {
        iv
      }
      mentionFontSize {
        iv
      }
      mentionTextColor {
        iv
      }
      showroom {
        iv{id}
      }
    }
  }
  types : queryRobeTypeListeContents(top: 100, skip: 0, filter: null, search: null) {
    data {
      value {
        iv
      }
      text {
        iv
      }
    }
  }
  longueurs : queryRobeLongueurListeContents(top: 100, skip: 0, filter: null, search: null) {
    data {
      value {
        iv
      }
      text {
        iv
      }
    }
  }
  manches : queryRobeManchesListeContents(top: 100, skip: 0, filter: null, search: null) {
    data {
      value {
        iv
      }
      text {
        iv
      }
    }
  }
  coupes : queryRobeCoupeListeContents(top: 100, skip: 0, filter: null, search: null) {
    data {
      value {
        iv
      }
      text {
        iv
      }
    }
  }
  decolletes : queryRobeDecolleteListeContents(top: 100, skip: 0, filter: null, search: null) {
    data {
      value {
        iv
      }
      text {
        iv
      }
    }
  }
  selections : queryDressSelectionContents(top: 100, skip: 0, filter: $dateFilter, search: null) {
    id
    data {
      title {
        iv
      }
    }
  }
}
`,
]);
